<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'AFFILIATION.AFFILIATIONS_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template *ngIf="!entityId" ngxPermissionsOnly="canAddAffiliation">
          <button
            mat-raised-button
            type="button"
            class="btn btn-primary"
            (click)="addAffiliation($event)"
          >
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'AFFILIATION.ADD_AFFILIATION' | translate }}</span>
          </button>
        </ng-template>
        <div *ngIf="!!entityId" class="btn-group">
          <button
            mat-raised-button
            type="button"
            data-toggle="dropdown"
            class="btn btn-primary dropdown-toggle"
          >
            <span
              inlineSVG="assets/media/svg/icons/General/link.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'AFFILIATION.LINK_AFFILIATION' | translate }}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-left dropdown-menu-anim-up px-15px py-0">
            <kt-general-autocomplete
              #affiliationAutocomplete
              [label]="'AFFILIATION.AFFILIATION' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getAffiliationAutocomplete$"
              [optionFormatter]="formatAffiliationOption"
              [valueFormatter]="formatAffiliationOption"
              [change]="handleAffiliationChange.bind(this)"
            ></kt-general-autocomplete>
          </div>
        </div>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            type="button"
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          type="button"
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'AFFILIATION.INPUT.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let affiliation">{{ affiliation.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'AFFILIATION.INPUT.ID' | translate }}</mat-label>
              <input matInput #searchIdInput [placeholder]="'AFFILIATION.INPUT.ID' | translate" />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                type="button"
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'AFFILIATION.INPUT.NAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let affiliation">
            <span
              [matTooltip]="canViewAffiliation() ? 'View Affiliation' : null"
              [class.clickable]="canViewAffiliation()"
              (dblclick)="updateViewAffiliation($event, 'VIEW', affiliation)"
              >{{ affiliation.name }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'AFFILIATION.INPUT.NAME' | translate }}</mat-label>
              <input
                matInput
                #searchNameInput
                [placeholder]="'AFFILIATION.INPUT.NAME' | translate"
              />
              <button
                *ngIf="searchNameInput.value"
                matSuffix
                mat-icon-button
                type="button"
                (click)="resetInput($event, searchNameInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'AFFILIATION.INPUT.EMAIL' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let affiliation">
            <a href="mailto:{{ affiliation.email }}">{{ affiliation.email }}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEmail">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'AFFILIATION.INPUT.EMAIL' | translate }}</mat-label>
              <input
                matInput
                #searchEmailInput
                [placeholder]="'AFFILIATION.INPUT.EMAIL' | translate"
              />
              <button
                *ngIf="searchEmailInput.value"
                matSuffix
                mat-icon-button
                type="button"
                (click)="resetInput($event, searchEmailInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="affiliationType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'AFFILIATION.INPUT.AFFILIATION_TYPE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let affiliation">{{ affiliation.affiliation_type_name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchAffiliationType">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchAffiliationTypeAutocomplete
              [label]="'AFFILIATION.INPUT.AFFILIATION_TYPE' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getAffiliationTypeAutocomplete$"
              [optionFormatter]="formatAffiliationTypeOption"
              [valueFormatter]="formatAffiliationTypeOption"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'AFFILIATION.INPUT.PHONE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let affiliation">{{ affiliation.phone | phoneFormat }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchPhone">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'AFFILIATION.INPUT.PHONE' | translate }}</mat-label>
              <input
                matInput
                #searchPhoneInput
                [placeholder]="'AFFILIATION.INPUT.PHONE' | translate"
              />
              <button
                *ngIf="searchPhoneInput.value"
                matSuffix
                mat-icon-button
                type="button"
                (click)="resetInput($event, searchPhoneInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="fax">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'AFFILIATION.INPUT.FAX' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let affiliation">{{ affiliation.fax | phoneFormat }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchFax">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'AFFILIATION.INPUT.FAX' | translate }}</mat-label>
              <input matInput #searchFaxInput [placeholder]="'AFFILIATION.INPUT.FAX' | translate" />
              <button
                *ngIf="searchFaxInput.value"
                matSuffix
                mat-icon-button
                type="button"
                (click)="resetInput($event, searchFaxInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let affiliation">
            <ng-container *ngIf="!entityId">
              <ng-template ngxPermissionsOnly="canViewAffiliation">
                <button
                  type="button"
                  matTooltip="{{ 'TABLE.VIEW' | translate }} Affiliation"
                  class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                  (click)="updateViewAffiliation($event, 'VIEW', affiliation)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/visible.svg"
                    class="svg-icon svg-icon-md svg-icon-success"
                  ></span>
                </button>
              </ng-template>
              <ng-template ngxPermissionsOnly="canEditAffiliation">
                <button
                  type="button"
                  matTooltip="{{ 'TABLE.UPDATE' | translate }} Affiliation"
                  class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                  (click)="updateViewAffiliation($event, 'UPDATE', affiliation)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-primary"
                  ></span>
                </button>
              </ng-template>
              <ng-template ngxPermissionsOnly="canSoftDeleteAffiliation">
                <button
                  type="button"
                  matTooltip="{{ 'TABLE.DELETE' | translate }} Affiliation"
                  class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                  (click)="deleteAffiliation($event, affiliation)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-danger"
                  ></span>
                </button>
              </ng-template>
            </ng-container>
            <button
              *ngIf="!!entityId"
              type="button"
              matTooltip="Unlink Affiliation"
              class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
              (click)="linkUnlinkAffiliation($event, affiliation, false)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/unlink.svg"
                class="svg-icon svg-icon-md svg-icon-warning"
              ></span>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              type="button"
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light w-50 m-1"
              (click)="resetSearchBar($event)"
            >
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
